import moment from "moment-timezone";

const getTimezone = () => {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return timeZone;
  } catch (error) {
    console.error("Error retrieving timezone:", error);
  }
};

export const dateFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD MMM YYYY,  hh:mm A") : "";
};

// Adjust the path to where your getTimezone function is located
export const monthFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("MM/YYYY") : "";
};

// In year month Date format
export const dateFormatYear = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("YYYY MM DD") : "";
};


export const calculateAge = (dob) => {
  const timezone = getTimezone();
  const birthDate = moment(dob).tz(timezone);
  const today = moment().tz(timezone);

  let age = today.diff(birthDate, 'years');
  if (today.isBefore(birthDate.clone().add(age, 'years'))) {
    age--;
  }

  return age;
};
// in utc

// export const dateFormatUtc = (date) => {
//   const timezone = getTimezone();
//   return date
//     ? moment(date).tz(timezone).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
//     : "";
// };
export const dateFormatUtc = (date) => {
  return date
    ? moment(date).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    : "";
};

export const dateFormatWithTime = (date) => {
  return date
    ? moment(date).tz("Asia/Kolkata").format("DD MMM YYYY, hh:mm A")
    : "";
};

export const timeFormat = (time) => {
  const timezone = getTimezone();
  return time ? moment(time).tz(timezone).format("hh:mm A") : "";
};

export const dobFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD MMM YYYY, hh:mm A") : "";
};


export const formatToTwoDecimalPoints = (num = 0) => {
  console.log("number", num)
  console.log(parsedNum, "ParsedNum");
  const parsedNum = parseFloat(num);
  // console.log(typeof parsedNum,"Parsed Num");
  if (isNaN(parsedNum)) {
    throw new Error('Input must be a number');
  }
  return +parsedNum.toFixed(2);
};

export const formatDuration = (seconds) => {
  seconds = Math.floor(seconds);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
  if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs} second${secs !== 1 ? 's' : ''}`);

  return parts.join(', ');
};

export const dateAdnTimeFormatUtc = (dateInput) => {
  {
    try {
      let momentDate;

      // Handle different input types
      if (typeof dateInput === 'string') {
        // Try parsing as ISO string (e.g., "2025-04-23T11:48:00.000Z")
        if (moment(dateInput, moment.ISO_8601, true).isValid()) {
          momentDate = moment.utc(dateInput); // Parse as UTC
        }
        // Try parsing as backend format (e.g., "23-04-2025 11:48:00")
        else if (moment(dateInput, 'DD-MM-YYYY HH:mm:ss', true).isValid()) {
          momentDate = moment.utc(dateInput, 'DD-MM-YYYY HH:mm:ss'); // Parse as UTC
        } else {
          return '';
        }
      } else if (dateInput instanceof Date) {
        momentDate = moment.utc(dateInput); // Convert Date to UTC
      } else {
        return '';
      }

      // Validate moment date
      if (!momentDate.isValid()) {
        return '';
      }

      // Format to "DD MMM YYYY, hh:mm A" in UTC
      return momentDate.format('DD MMM YYYY, hh:mm A');
    } catch (error) {
      console.error('Error formatting date with Moment.js:', error);
      return '';
    }
  }
};
